import { ThemeProvider } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { SnackbarProvider } from "notistack";
import FirebaseContextProvider from "./Firebase/FirebaseContext";
import Routes from "./Routes";
import { theme } from "./Theme";
import DateFnsUtils from "@date-io/date-fns";
import { MODE_DEMO, BANDEAU_DEMO } from "./Utils/demoMode";
import fr from "date-fns/locale/fr";

function App() {
  return (
    <FirebaseContextProvider>
      <SnackbarProvider maxSnack={3}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={fr}>
          <ThemeProvider theme={theme}>
            {/* Bandeau permanent : une capture de demonstration ne doit jamais
                pouvoir passer pour une capture de production. */}
            {MODE_DEMO && (
              <div
                style={{
                  background: "#B91C1C",
                  color: "#fff",
                  textAlign: "center",
                  fontSize: 12,
                  fontWeight: 700,
                  padding: "4px 0",
                  letterSpacing: 0.4,
                }}
              >
                {BANDEAU_DEMO}
              </div>
            )}
            <Routes></Routes>
          </ThemeProvider>
        </MuiPickersUtilsProvider>
      </SnackbarProvider>
    </FirebaseContextProvider>
  );
}

export default App;
